/**
 * @generated SignedSource<<06cda3a21e65963b46693219051c3416>>
 * @relayHash 4c3eeb5f92d01aa5ff5385d1c0f9e345
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8b627002b040a8a157a95ea88cf03c6c81b4252962dc9c0a42a1b10657745b90

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ui_jiraCalendarQuery } from './ui_jiraCalendarQuery.graphql';

const node: PreloadableConcreteRequest<ui_jiraCalendarQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "8b627002b040a8a157a95ea88cf03c6c81b4252962dc9c0a42a1b10657745b90",
    "metadata": {},
    "name": "ui_jiraCalendarQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
